import { HttpServices } from './http.services'
import { API_URL } from './config.services'

async function getUser(email: string) {
  const data = {
    user_email: email,
  }
  return HttpServices.doGet(`${API_URL}/getUser`, data)
}

export const userService = {
  getUser,
}
